import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exo/dot-spinner";

const AustraliaMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		australiaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/australia.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexAustralia.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const australiaMapObject = loaded.australiaMapObject.default;

		return (
			<Map
				{...props}
				baseIcon={false} // Pass a tiny map svg/js object here, or false to disable
				baseMapObject={australiaMapObject}							
				clickableStates={[
					"AU-ACT",
					"AU-NSW",
					"AU-NT",
					"AU-QL",
					"AU-SA",
					"AU-TAS",
					"AU-VIC",
					"AU-WA",
				]}
				// dmaMap={false}
				filtering={false}
				filterByMapCountry={props.filterByMapCountry}
				interactiveEmptyMap={true}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				// mapCountyHighlight={false}
				// mapCountyHighlightId={""}
				// mapCountyHighlightColor={""}
				// mapCountyHighlightTitle={""}
				// mapCountyHighlightValue={""}
				mapHighlight={false}
				// mapHighlightColor={""}
				mapHighlightDisabled={false}
				mapId="base"
				mapIndex={mapIndex}
				// mapPlaying={false} // false or string. 'playing' or 'stopped'. false is all state
				// mapPosition={false}
				maxHeight={600} // 400 for US map
				moeMode={false}
				reactSimpleMaps={null}
				states={null}
				subtractFromHeight={100} // 360 for US map
				wideMap 

				// actions
				changeMap={actions.changeMap}
				clearMap={actions.clearMap}
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				stateFilterParentId={"sourceProvince"}
				toggleFilterByMapCountry={actions.toggleFilterByMapCountry}
				toggleMapPlay={actions.toggleMapPlay}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default AustraliaMapLoader;
